import { getDrawer } from "api";
import { useQuery } from "@tanstack/react-query";

// eslint-disable-next-line
const useQueryDrawer = (id: string, options?: any) => {
  return useQuery(["drawer", id], () => getDrawer(id), options);
};

export default useQueryDrawer;
